import React from "react";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";

/**
 * Mobile-only back control. Hidden on lg+ screens.
 * Goes back in history, or home if there is no history.
 */
const MobileBackButton = ({ className = "", size = 28, fallback = "/" }) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      aria-label="Go back"
      onClick={() => {
        if (window.history.length > 1) navigate(-1);
        else navigate(fallback);
      }}
      className={`lg:hidden flex items-center justify-center text-black shrink-0 ${className}`}
      style={{ width: size, height: size }}
    >
      <IoMdArrowBack size={size} />
    </button>
  );
};

export default MobileBackButton;
